import { SET_LOADING, SAVE_DATA, SAVE_BULK_USERS } from './constants';
import { CLEAR_STATE } from '../HandleAPICalls/constants';

const initialState = { loading: true, corporateList: [], bulkUsers: [] };

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.isLoading,
      };
    case SAVE_BULK_USERS:
      return {
        ...state,
        bulkUsers: action.data,
      };
    case SAVE_DATA:
      return {
        ...state,
        corporateList: action.data,
      };
    case CLEAR_STATE:
      return initialState;
    default: return state;
  }
}


// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/reducer.js